import { UseMarketOpportunities } from "../actions/markets"

export const UseMarketsInfo = async()=>{
    const market = await UseMarketOpportunities();
    const data = market.data;
    var result = {};
    await data.map((item,index)=>{
        result[item.symbol] = item;
    })
    return result;
}